"use client";

import { CrystalPreview } from "@/components/product/CrystalPreview";
import { CrystalCustomizer } from "@/components/product/CrystalCustomizer";
import { CrystalCustomizerProvider } from "@/contexts/CrystalCustomizerContext";
import { CanvasLayout } from "@/components/layout/CanvasLayout";
import { Menu } from "lucide-react";
import { FloatingButton } from "@/components/common/FloatingButton";

export default function HomePage() {
  return (
    <div className="h-screen bg-background">
      <FloatingButton
        position="top-left"
        href="/navigation"
        buttonClassName="w-fit justify-between"
      >
        <Menu className="h-3 w-3" />
        <span className="font-medium">More Features</span>
      </FloatingButton>

      {/* 主内容区 - 使用Context Provider统一管理状态 */}
      <CrystalCustomizerProvider>
        <CanvasLayout>
          <CanvasLayout.Main>
            <CrystalPreview />
          </CanvasLayout.Main>
          <CanvasLayout.Panel>
            <CrystalCustomizer />
          </CanvasLayout.Panel>
        </CanvasLayout>
      </CrystalCustomizerProvider>
    </div>
  );
}
